<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="活动时间">
        <el-date-picker v-model="search.beginTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
      </el-form-item>
      <el-form-item label="活动状态">
        <el-select v-model="search.status" placeholder="选择活动状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in activityStatus.filter((item) => item.id != 2 && item.id != 4)" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="activity-preorder operation-bar">
      <el-button size="small" type="primary" @click="releaseActivities">
        <svg-icon icon-class="public" />
        立即发布
      </el-button>
    </div>
    <tableList ref="multipleTable" :table-query="search" :query-function="$Api.activity.postThemActivityList" size="small" style="width: 100%" @selection-change="selectionItemChange">
      <el-table-column type="selection" width="55" fixed :selectable="(row) => row.status == 1" />
      <el-table-column prop="id" label="活动ID" width="80" fixed />
      <el-table-column prop="name" label="活动标题" />

      <el-table-column prop="status" label="活动状态">
        <template slot-scope="scope">
          <el-tag :type="activityStatus[scope.row.status].color" size="mini">{{ activityStatus[scope.row.status].value }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="beginTime" label="活动开始日期" />
      <!--      <el-table-column prop="city" label="活动城市" />-->
      <el-table-column fixed="right" width="130px" label="操作">
        <template slot-scope="{row}">
          <el-button v-if="row.status !== 3" size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="copy(row)">复制</el-button>
          <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </tableList>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
  </div>
</template>
<script>
// import { mapState } from 'vuex'
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';

export default {
  components: { tableList, Dialog },
  data() {
    const activityStatus = [
      { id: 0, value: '已发布', color: 'success' },
      { id: 1, value: '草稿', color: 'warning' },
      { id: 2, value: '已发布', color: 'success' },
      { id: 3, value: '已结束', color: 'info' },
      { id: 4, value: '草稿', color: 'warning' },
    ];
    return {
      search: {
        // city: '',
        status: '',
        name: '',
        beginTime: '',
      },
      activityStatus,
      selectionId: [],
      formDialogShow: false,
      currentID: -1,
      information: {},
    };
  },
  computed: {
    // 获取城市列表
    // cityList() {
    //   return this.$store.state.activity.citySelectVO;
    // },
  },
  mounted() {
    console.log('mounted', this.$refs['multipleTable'].paginationParams);
  },
  methods: {
    add() {
      this.$router.push({ path: '/activity/topic/add' });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      let subTitle = '';
      switch (row.status) {
        case 0:
          subTitle = `活动已发布，编辑将会更新活动信息，是否继续？`;
          break;
        case 1:
          subTitle = `是否确认编辑活动ID为“${row.id}”的数据项？`;
          break;
        case 2:
          subTitle = `活动已发布，编辑将会更新活动信息，是否继续？`;
          break;
        case 3:
          subTitle = `是否确认编辑活动ID为“${row.id}”的数据项？`;
          break;
        default:
          break;
      }
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle,
      };
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后小程序用户将无法查看该活动，请确认是否删除',
        // subTitle: `是否确认删除活动ID为“${row.id}”的数据项？`,
      };
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.$Api.activity.deleteActivity({ activityIds: this.currentID }, { hideMessage: true }).then(() => {
          this.formDialogShow = false;
          this.$message.success('删除成功');
          const tableData = this.$refs['multipleTable'].$data.tableData || [];
          let page = this.$refs['multipleTable'].paginationParams.current;
          page = (page -= tableData.length == 1 && 1) ? 1 : page;
          this.$refs['multipleTable'].getTableList();
        });
        //     .catch(error => {
        //   this.formDialogShow = true;
        //   this.information = {
        //     operation: 'error',
        //     icon: 'error',
        //     subTitle: `${error.errorMessage}`,
        //   };
        // });
      } else if (operation === 'copy') {
        this.$router.push({ path: '/activity/topic/add', query: { copyid: this.currentID }});
      } else if (operation === 'edit') {
        this.$router.push({ path: '/activity/topic/edit', query: { id: this.currentID }});
      }
    },
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    // 当选择项发生变化时会触发该事件
    selectionItemChange(selection) {
      this.selectionId = selection.reduce((init, item) => {
        init.push(item.id);
        return init;
      }, []);
    },
    // 开放报名
    releaseActivities() {
      this.$Api.activity.releaseThemaActivities({
        activityIds: this.selectionId.join(','),
      }).then(() => {
        this.$message.success('发布成功');
        this.$refs['multipleTable'].searchAndReset();
      });
    },
  },
};
</script>
